import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { environment } from '../../../environments/environment';

export class TranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: object,
    public readonly prefix: string = '/assets/i18n/',
    public readonly suffix: string = '.json'
  ) {}

  public getTranslation(lang: string): Observable<object> {
    if (isPlatformServer(this.platformId)) {
      // SSR-only dynamic imports
      const fs = eval('require')('fs');
      const path = eval('require')('path');

      try {
        const filePath = path.join(process.cwd(), 'dist/watch-this-garage/browser', this.prefix, `${lang}${this.suffix}`);
        const file = fs.readFileSync(filePath, 'utf8');
        return of(JSON.parse(file));
      } catch (error) {
        console.error(`TranslateHttpLoader SSR error:`, error);
        return of({});
      }
    }

    // Browser fallback
    return this.http.get(`${this.prefix}${lang}${this.suffix}?v=${encodeURIComponent(environment.version)}`);
  }
}
